// extracted by mini-css-extract-plugin
export var icon = "_7b-1";
export var subtext = "_7b-0";